<template>
  <div
    class="
      sf-level sf-level-between
      sf-companies-list-progress__container
      sf-bg-white
    "
    data-testid="companies-list-progress"
  >
    <div class="sf-level">
      <insights-actions @download-as-excel="downloadCompaniesList" />
      <search-input
        class="!tw-min-w-60"
        :focused-at="searchFocusedAt"
        :placeholder="searchPlaceholder"
        :show-result-navigation="false"
        :model-value="searchTerm"
        @update:model-value="updateSearchTerm"
      ></search-input>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import InsightsActions from '../actions/insights-actions.vue'
import SearchInput from '@app/shared/vue/components/sf-search/search-input.vue'
import { filters } from '@app/insights/constants'
import zipcelx from 'zipcelx'

export default {
  name: 'InsightsCompaniesListProgress',
  components: {
    SearchInput,
    InsightsActions,
  },
  provide() {
    return {
      isLite: this.isLite,
    }
  },
  props: {
    isLite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchFocusedAt: null,
    }
  },
  computed: {
    ...mapState({
      companiesFullyLoaded: (state) => state.companies.companiesFullyLoaded,
      companiesFullyLoadedAt: (state) => state.companies.companiesFullyLoadedAt,
      segment: (state) => state.segments.segment,
      triggers: (state) => state.triggers.triggers,
      isSegmentLoading: (state) => state.segments.isSegmentLoading,
      activeFilters: (state) => state.filters.activeFilters,
      period: (state) => state.periodSelection,
      searchTerm: (state) => state.companies.searchTerm,
      selectedCompanies: (state) => state.companies.selectedCompanies,
    }),
    ...mapGetters([
      'allCompaniesProcessed',
      'sortedAndFilteredCompanies',
      'companyColumns',
    ]),

    loading() {
      return !this.allCompaniesProcessed
    },
    searchPlaceholder() {
      return I18n.t('companies_overview.progress_v2.search_placeholder')
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyboardSearch)
  },
  unmounted() {
    window.removeEventListener('keydown', this.handleKeyboardSearch)
  },
  methods: {
    ...mapActions(['updateSearchTerm']),
    handleKeyboardSearch(event) {
      if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
        event.preventDefault()
        this.searchFocusedAt = Date.now()
      }
    },
    downloadCompaniesList() {
      const config = {
        filename: 'companies_overview',
        sheet: {
          data: this.excelData(),
        },
      }
      zipcelx(config)
    },

    excelData() {
      const headerForId = {
        value: I18n.t('companies_overview.company_id'),
        type: 'string',
      }

      const headers = this.companyColumns.map((column) => {
        return { value: column.title, type: 'string' }
      })

      return [[headerForId, ...headers], ...this.excelValues()]
    },

    excelValues() {
      const numericFilterTypes = [filters.FORMULA]

      return this.sortedAndFilteredCompanies.reduce((result, company) => {
        if (!this.isCompanySelected(company)) {
          return result
        }

        const rowData = company.filter_values
        const columnWithId = {
          value: company.id,
          type: 'number',
        }

        const excelCells = this.companyColumns.map((column) => {
          if (rowData[column.name].filter_error) {
            return {
              value: window.I18n.t('companies_overview.filters.not_applicable'),
              type: 'string',
            }
          }

          if (
            column.filter &&
            numericFilterTypes.includes(column.filter.type)
          ) {
            return {
              value: rowData[column.name].sort_value,
              type: 'number',
            }
          }

          return {
            value: rowData[column.name].formatted_value,
            type: 'string',
          }
        })

        result.push([columnWithId, ...excelCells])
        return result
      }, [])
    },
    isCompanySelected(company) {
      return this.selectedCompanies.has(company.id)
    },
  },
}
</script>

<style scoped lang="scss">
.sf-companies-list-progress {
  &__container {
    grid-area: info;

    .inline-alert-banner {
      height: 36px;
    }
  }
}
</style>
